/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import { Button, Row, Col, Modal, Table, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import axios from 'axios';

// project imports
import { MyAccountMenuList } from '../MyAccountMenuList';
import { invoiceDetail, transactionHistory,invoicePrintPdf  } from 'shared/settings/apiconfig';
import store from 'features/store';
import { getBuyersUrl, getBuyerHeaders } from 'shared/http';
import { LocationService } from 'shared/services';
import { isAuthorized } from 'shared/settings/auth';
//style imports
import './InvoiceView.scss';
import ToasterMessage from 'shared/toast/toast';
import { responseCodeAndStatus } from './DeclinedCardStatus';
import { getItemUrl } from 'shared/utils/utils';
import * as momentTz from 'moment-timezone'
import { Loader } from 'shared/hoc/loader/Loader';

/**

@param

@return html code for invoice ra view

**/

class InvoiceRaView extends Component {
    status = { 'paid': 'fa-check-circle', 'unpaid': 'fa-times-circle' };
    address = ['city', 'state', 'country', 'zipcode'];
    pdfRef;
    a;
    blob;

    constructor(props) {
        super(props);
        this.toasterMessage = createRef();
        this.state = {
            pageLoading: false,
            windowWidth: window.innerWidth,
            transactionModal: false,
            transactionData: [],
            invoiceview: 0,
            mirstatus: this.props?.location?.state?.mirstatus,
            dgstatus: this.props?.location?.state?.dgstatus,
            shippeditem: this.props?.location?.state?.shippeditem,
            form: {
                id: Number(this.props.match.params.invoiceId),
                billingto: {
                    name: '',
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    country: '',
                    zipcode: '',
                    cityState: '',
                    countryZipcode: '',
                    email: '',
                    phonenumber: ''
                },
                billingfrom: {
                    contactname: '',
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    country: '',
                    zipcode: '',
                    cityState: '',
                    countryZipcode: '',
                    contactemail: '',
                    contactmobile: ''
                },
                items: [],
                total: '',
                child_invoice: [],
                masterId: "",
                masterinvoicenumber: "",
                tax: '',
                grossamount: '',
                amountdue: '',
                status: '',
                invoicenumber: '',
                createddate: '',
                timezone: '',
                totalgrossamount: '',
                totalInvoiceAmount : '' ,
                totalInvoicePendingAmount : '' ,
                invoiceStatusAll : '' ,
                invoicevendor: '',
                type: '',
                invoicemessage: '',
                vipMember: false,
            },
            downloadPdf: false,
            printPdf: false,
            noDataFound: false,
            saletitle: null,
            saleid: null,
            serverURL: "",
            pendingAmount: "",
            totalInvoiceAmount : 0,
            totalInvoicePendingAmount : 0,
            totalInvoiceAmountPaid : 0,
        }
        this.pdfRef = createRef();
        this.circleCheckImage = '';
        this.circleCrossImage = '';
    }

    componentDidMount() {
        this.getServerUrl();
        window.addEventListener('resize', this.updateDimensions);
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });
        if (isAuthorized()) {
            this.getInvoiceData();
        } else {
            store.dispatch({ type: 'SET_EXTRA_Z_INDEX', payload: true });
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
        }
    }
    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            this.getInvoiceData();
            store.dispatch({ type: 'SET_EXTRA_Z_INDEX', payload: false });
        }
    }
    printPdf(values) {

        if (values == 'download') {
            this.setState({
                downloadPdf: true
            })
        }
        else if(values == 'print'){
            this.setState({
                printPdf: true
            })
        }

        let child_invoice = this.state.form.child_invoice[0]?.id ? this.state.form.child_invoice[0]?.id : '';
        let parent_invoce = this.state.form.id
        let invoiceId = child_invoice ? [parent_invoce, child_invoice] : [parent_invoce]
        const data = {
            "saleid": this.state.saleid,
            "invoiceid": invoiceId,
            "type": "print"
        }
        let config = getBuyerHeaders()
        config['responseType'] = 'blob';
        axios.post(getBuyersUrl(invoicePrintPdf), JSON.stringify({ data }), config).then((response) => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const fileURL = window.URL.createObjectURL(blob);

            if (values === 'print') {
                window.open(fileURL, '_blank');
                this.setState({ printPdf: false})
            }

            if (values === 'download') {
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'Download.pdf';
                alink.click();
                this.setState({ downloadPdf: false})
            }
        })
    }

    getServerUrl = () => {
        const absoluteURL = window.location.href;
        const path = this.props.location.pathname;
        const check = absoluteURL.split(path)[0];
        this.setState({
            serverURL: check
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });
        store.dispatch({ type: 'SET_EXTRA_Z_INDEX', payload: false });
    }

    /* Detect window width */
    updateDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    /* Get invoice data of the buyer */
    getInvoiceData = () => {
        this.setState({ pageLoading: true });
        axios.get(getBuyersUrl(`${invoiceDetail}/${Number(this.state.form.id)}`), getBuyerHeaders())
            .then(async response => {
                if (response.data.status === 'success') {
                    if (response.data.data.length) {
                        let invoiceData = response.data.data[0];
                        this.setState({
                            invoiceview : invoiceData.invoiceview
                        })
                        if(invoiceData.masterinvoiceid && (invoiceData.invoicestatus).toLowerCase() != "void"){
                            this.setState({
                                ...this.state.form,
                                form: {
                                    id: invoiceData.masterinvoiceid,
                                    totalInvoiceAmount : 0,
                                    totalInvoicePendingAmount : 0,
                                    totalInvoiceAmountPaid : 0,
                                }
                            })
                            await this.getInvoiceData()
                        } else {
                            this.getTransactionData();
                            let data = JSON.parse(response.data.data[0].details);

                            this.setState({
                                form: {
                                    ...this.state.form,
                                    masterId: invoiceData.masterinvoiceid ? invoiceData.masterinvoiceid : "",
                                    masterinvoicenumber: invoiceData.masterinvoicenumber ? invoiceData.masterinvoicenumber : "---",
                                }
                            }, () => {
                                const locationDetailData = { "sort": [{ "field": "title", "direction": "asc" }] };
                                LocationService.getLocationDetails(invoiceData.locationid, locationDetailData).then(
                                    locationResponse => {
                                        let billingfromCityDelimiter = data.billingfrom.city && data.billingfrom.state ? ', ' : '';
                                        let billingfromCountryDelimiter = data.billingfrom.country && data.billingfrom.zipcode ? ', ' : '';
                                        let billingtoCityDelimiter = data.billingto.city && data.billingto.state ? ', ' : '';
                                        let billingtoCountryDelimiter = data.billingto.country && data.billingto.zipcode ? ', ' : '';
                                        let invoiceMessage = data.invoicemessage ?  JSON.parse(data?.invoicemessage) : ''
                                        this.setState({
                                            form: {
                                                ...this.state.form,
                                                billingto: {
                                                    ...this.state.form.billingto,
                                                    name: data.billingto.firstname + ' ' + data.billingto.lastname,
                                                    address1: (data.billingto.address1 ? data.billingto.address1 + ', ' : '') + (data.billingto.address2 ? data.billingto.address2 + ', ' : ''),
                                                    city: data.billingto.city,
                                                    state: data.billingto.state,
                                                    country: data.billingto.country,
                                                    zipcode: data.billingto.zipcode,
                                                    cityState: (data.billingto.city ? data.billingto.city : '') + (billingtoCityDelimiter) + (data.billingto.state ? data.billingto.state : ''),
                                                    countryZipcode: (data.billingto.country ? data.billingto.country : '') + (billingtoCountryDelimiter) + (data.billingto.zipcode ? data.billingto.zipcode : ''),
                                                    email: data.billingto.contactemail ? data.billingto.contactemail : data.billingto.email ? data.billingto.email : '',
                                                    phonenumber: data.billingto.contactmobile ? data.billingto.contactmobile : data.billingto.mobile ? data.billingto.mobile : '',
                                                },
                                                billingfrom: {
                                                    ...this.state.form.billingfrom,
                                                    contactname: data.billingfrom.contactname,
                                                    address1: (data.billingfrom.address1 ? data.billingfrom.address1 + ', ' : '') + (data.billingfrom.address2 ? data.billingfrom.address2 + ', ' : ''),
                                                    city: data.billingfrom.city,
                                                    state: data.billingfrom.state,
                                                    country: data.billingfrom.country,
                                                    zipcode: data.billingfrom.zipcode,
                                                    cityState: (data.billingfrom.city ? data.billingfrom.city : '') + (billingfromCityDelimiter) + (data.billingfrom.state ? data.billingfrom.state : ''),
                                                    countryZipcode: (data.billingfrom.country ? data.billingfrom.country : '') + (billingfromCountryDelimiter) + (data.billingfrom.zipcode ? data.billingfrom.zipcode : ''),
                                                    contactemail: data.billingfrom.contactemail ? data.billingfrom.contactemail : data.billingfrom.email ? data.billingfrom.email : '',
                                                    contactmobile: data.billingfrom.contactmobile ? data.billingfrom.contactmobile : data.billingfrom.mobile ? data.billingfrom.mobile : '',
                                                },
                                                items: data.items,
                                                total: data.invoiceamount ? data.invoiceamount : data.totalamount ? data.totalamount : '',
                                                tax: data.tax,
                                                grossamount: data.grossamount,
                                                amountdue: data.amountdue ? data.amountdue : invoiceData.invoiceamount,
                                                status: invoiceData.invoicestatus,
                                                invoicenumber: invoiceData.invoicenumber,
                                                createddate: invoiceData.createddate,
                                                timezone: invoiceData.timezonename,
                                                totalInvoiceAmount : invoiceData.invoiceamount ? (Number(this.state.form.totalInvoiceAmount) + Number(invoiceData.invoiceamount)) : Number(this.state.form.totalInvoiceAmount),
                                                totalInvoiceAmountPaid : this.calculatePaymentReceived(invoiceData.invoiceamount, invoiceData.pendingamount),
                                                totalInvoicePendingAmount : invoiceData.pendingamount ? (Number(this.state.form.totalInvoicePendingAmount) + Number(invoiceData.pendingamount)) : Number(this.state.form.totalInvoicePendingAmount),
                                                invoicevendor: invoiceData.invoicevendor,
                                                type: invoiceData.type,
                                                invoicemessage: invoiceMessage?.content?.body,
                                                vipMember: data.vipmember
                                            },
                                            pageLoading: false,
                                            saletitle: invoiceData.saletitle,
                                            saleid: invoiceData.saleid,
                                            pendingAmount: invoiceData.pendingamount ? invoiceData.pendingamount : 0,
                                        }, () => this.calculateTotal());
                                    }
                                ).catch(error => {
                                    this.setState({ pageLoading: false, noDataFound: true });
                                });
                            })
                        }
                    } else {
                            this.setState({ noDataFound: true, pageLoading: false })
                        }
                    }
            })
            .catch(error => {
                this.setState({ pageLoading: false, noDataFound: true });
            });
    }

    // get payment received
    calculatePaymentReceived = (invoiceAmount, pendingAmount) => {
        let totalInvoiceAmt = Number(this.state.form.totalInvoiceAmount)
        let totalPendingAmt = Number(this.state.form.totalInvoicePendingAmount)
        if(invoiceAmount) {
            totalInvoiceAmt += Number(invoiceAmount)
        }
        if(pendingAmount) {
            totalPendingAmt += Number(pendingAmount)
        }
        return totalInvoiceAmt - totalPendingAmt
    }

    /* calculate total */
    calculateTotal = () => {
        let amountTotal = 0;
        let grossamountTotal = 0;
        this.state.form.items.forEach(item => {
            amountTotal = amountTotal + parseFloat(item.amount);
            grossamountTotal = grossamountTotal + parseFloat(item.grossamount);
        });

        this.setState({
            form: {
                ...this.state.form,
                totalgrossamount: grossamountTotal ? grossamountTotal : 0,
                totalamount: amountTotal ? amountTotal : 0
            }
        });
    }
    navigateToCorrectPath = () => {
        const { mirstatus, dgstatus, shippeditem } = this.state;
        const { history } = this.props;
    
        if (mirstatus) {
            history.push({pathname : `/my-account/mir`, state: this.props?.location?.state});
          } else if (dgstatus) {
            history.push({pathname : `/my-account/gd`,  state: this.props?.location?.state});
          } else if (shippeditem) {
            history.push({pathname : `/my-account/invoice/shipped-items`,  state: this.props?.location?.state});
          } else {
            history.push({pathname : `/my-account/invoice`, state: this.props?.location?.state});
          }
      };
    /* Get transaction history data */
    getTransactionData = () => {
        const data = {
            filter: [
                { field: 'invoiceid', value: Number(this.state.form.id), op: '=', join: 'AND' }
            ]
        };
        this.setState({ pageLoading: true });

        axios.post(getBuyersUrl(transactionHistory), JSON.stringify(data), getBuyerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({ transactionData: response.data.data });
                }
            })
            .catch(error => {
                this.setState({ pageLoading: false });
            })
    }

    viewItem = (e, item) => {
        e.preventDefault();
        this.props.history.push(getItemUrl(this.state.saleid, item.id, item.itemseourl));
    }

    getTransactionMessage = (data) => {
        try {
            if(data) {
                let parsedData = JSON.parse(data)
                parsedData = ("data" in parsedData && parsedData?.data ) ? parsedData.data: parsedData
                let responseCode = parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.processor_response?.response_code
                let message = parsedData?.message ? parsedData.message : responseCode ?  `${responseCode} - ${responseCodeAndStatus?.[responseCode]}` : 'Please contact CTBIDS help desk'
                return message ? message : "---"
            }
        } catch (err) {
            //handle err
        }
        return '';
    }
    
    captializeLetter = (data) => {
        const capitalized = data.charAt(0).toUpperCase() + data.slice(1);
        return capitalized;
    }

    render() {
        return (
            <div className={`invoice-view-main ${isAuthorized() ? '' : 'disable-page'}`}>
                {
                    !isAuthorized() ? <div className="un-auth-page d-flex align-items-center justify-content-center">
                        <div className={`h2 text-center ${this.props.toggleSignInModal?.open ? 'reduce-pad' : ''}`}>
                            Kindly login to view <br></br> the invoice
                        </div>
                    </div> : null
                }
                {
                    this.state.pageLoading ?
                       <Loader />:
                        !this.state.noDataFound ?
                            <div className="main-content mt-5 container">
                                <div className="d-flex">
                                    <div className=" w-50 justify-content-start text-left mt-3">
                                        <Button style={{ backgroundColor: '#A50050' }} onClick={() => this.navigateToCorrectPath()}className="m-1"><i className="fa fa-chevron-left pr-2"></i>Back</Button>
                                        <Button onClick={() => this.setState({ transactionModal: true })} className="transactionButton m-1">Transaction History</Button>
                                    </div>
                                    <div className=" w-50 d-flex justify-content-end align-items-baseline text-right mt-3">
                                        <ToasterMessage className="alert-handle" ref={this.toasterMessage}></ToasterMessage>
                                        <Button variant="dark" className="m-1" disabled={this.state.printPdf} onClick={() => this.printPdf('download')}>Download  {this.state.downloadPdf ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null} </Button>
                                        <Button variant="secondary" className="m-1 printBackground" onClick={() => this.printPdf('print')} disabled={this.state.downloadPdf} >Print {this.state.printPdf ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                    </div>
                                </div>
                                <div className="invoiceBorder mt-3">
                                    <div id="invoiceGenration" className="print" ref={this.pdfRef} >
                                        <div className="p-4 border-bottom  mx-0 media-screen-900 justify-content-center">
                                            <div className={` ${this.state.windowWidth > 800 ? 'd-flex text-left align-items-center flex-column wd-30' : 'd-flex text-left align-items-center flex-column wd-50'}`}>
                                                <div className='d-flex align-items-center justify-content-center media-screen'>
                                                    <img className="seel-img" style={{ borderRight: "4px solid #000000", height: "40px", marginLeft: "15px", paddingRight: "10px", width:'120px' }} src={`${process.env.PUBLIC_URL}/static/logo/Seel.png`} alt="logo" />
                                                    <img className='pdf-img-800' style={{ marginLeft: "5px" }} src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`} alt="logo" />
                                                </div>
                                                <div><b>Make it Returnable Provided By Seel</b></div>
                                            </div>
                                            <div className={`${this.state.windowWidth > 800 ? 'justify-content-end mt-3' : 'justify-content-center text-center mt-1 w-100'}`} style={{ fontSize: "20px", textAlign: "right", width: '65%' }}>
                                                {this.state.form.type ? 
                                                    <div className={` text-secondary col-xs-12`}><div style={{ fontSize: "20px", whiteSpace: 'nowrap', color: '#00263E' }}><b className='text-secondary'>Invoice Type: </b> {this.state.form.type == "RA" ? "Make It Returnable (MIR)" : "  - - -"}</div></div> : ""
                                                }
                                            </div>
                                        </div>
                                        <div className="d-flex row p-4 border-bottom mx-0">
                                            <div className={`col col-xs-12 padding col-md-6`}>
                                                <p><b className="text-secondary"> Billing To</b></p>
                                                {Object.keys(this.state.form.billingto).map((key) =>
                                                    !this.address.includes(key) ?
                                                        key === 'name' ? <p><b>{this.state.form.billingto[key]}</b></p> :
                                                            key === 'phonenumber' ? this.state.form.billingto[key] ? <p style={{ color: "#1d9aa5" }} >Phone No: {this.state.form.billingto[key]}</p> : '' :
                                                                key === 'email' ? <p style={{ color: "#1d9aa5", wordBreak: 'break-all' }} >{this.state.form.billingto[key]}</p> : <p style={{ wordBreak: 'break-all' }}>{this.state.form.billingto[key]}</p> : ''
                                                )}
                                            </div>
                                            <div className={`col col-xs-12 padding col-md-6`}>
                                                <p><b className="text-secondary">Billing From</b></p>
                                                {Object.keys(this.state.form.billingfrom).map((key) =>
                                                    !this.address.includes(key) ?
                                                        key === 'contactname' ? <p><b>{this.state.form.billingfrom[key]}</b></p> :
                                                            key === 'contactmobile' ? this.state.form.billingfrom[key] ? <p style={{ color: "#1d9aa5" }}>Phone No: {this.state.form.billingfrom[key]}</p> : '' :
                                                                key === 'contactemail' ? <p style={{ color: "#1d9aa5" }}>{this.state.form.billingfrom.contactemail} </p> : <p>{this.state.form.billingfrom[key]}</p> : ''
                                                )}
                                            </div>
                                        </div>
                                        <div className=''>
                                            <div className={` p-4 border-bottom mx-0`}>
                                                <div style={{ fontSize: "20px" }}><p><b className="text-secondary">Invoice Details</b></p></div>
                                            </div>
                                            <div className={`${this.state.windowWidth > 800 && "d-flex row"} p-4  mx-0`} style={{ display: 'flex' }}>
                                                <div className="col col-md-6 col-xs-12 padding"><div >
                                                    <p className={` text-secondary col-xs-12`} ><b style={{ fontSize: "20px" }}>Invoice: {this.state.form.invoicenumber}    </b>
                                                        {<span className={`${this.state.form.status.toLowerCase() === 'paid' ? "text-success" : "text-danger"}`}>
                                                            <i className={`fa ${this.status[this.state.form.status.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true" style={{marginRight: '5px'}}></i>{this.state.form.status.toUpperCase()}</span>}</p></div>
                                                </div>
                                                <div className="col col-md-6 col-xs-12 padding" style={{ textAlign: "right" }}>
                                                    <p><b className="text-secondary">Invoice Date :- </b>
                                                        <b>{moment.utc(this.state.form.createddate).local().format('MM/DD/YYYY hh:mm A')} {moment.tz(moment.tz.guess()).zoneAbbr()}</b>
                                                    </p>
                                                </div>
                                            </div>
                                            <div style={{ overflowX: "auto" }}>
                                                <Table className="amountfields" responsive>
                                                    <thead>
                                                        <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                                            <td style={{ paddingLeft: "2.5rem" }}>Item Title</td>
                                                            <td>SKU</td>
                                                            {!this.state.invoiceview ? <td>IRM</td> : null}
                                                            <td>MIR Amount</td>
                                                            <td style={{ paddingRight: "2.5rem" }}>Gross Amount</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.form.items.map((item, index) => (
                                                                <tr>
                                                                    <td style={{ paddingLeft: "2.5rem" }} width="25%">
                                                                        <a className="invoice-link-color" href={getItemUrl(this.state.saleid, item.id, item.itemseourl)} onClick={(event) => this.viewItem(event, item)}>
                                                                            {item.title}
                                                                        </a>
                                                                    </td>
                                                                    <td width="20%" style={{ wordBreak: "break-word" }} class="id">{item.SKU ? item.SKU : "- - -"}</td>
                                                                    {!this.state.invoiceview ? <td width="5%" style={{ whiteSpace: "nowrap" }} class="id">{item.bidderirm ? this.captializeLetter(item.bidderirm) : '- - -'}</td> : null}
                                                                    <td width="10%" style={{ whiteSpace: "nowrap" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</td>
                                                                    <td width="10%" style={{ paddingRight: "2.5rem", whiteSpace: "nowrap" }}>{item.grossamount ? `$ ${parseFloat(item.grossamount).toFixed(2)}` : '- - -'}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr style={{ fontWeight: "bold", flexWrap: "nowrap" }}>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalamount).toFixed(2)}</td>
                                                            <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalgrossamount).toFixed(2)}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>

                                        </div>

                                        <div className="serviceview" style={{ marginBottom: '50px' }}>
                                            <Row className="">
                                                <Col></Col>
                                                <Col className="text-end text-secondary"><b>Total Amount</b></Col>
                                                <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "20px !important" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "32%" }}>{this.state.form.totalInvoiceAmount ? `$ ${parseFloat(this.state.form.totalInvoiceAmount).toFixed(2)}` : '- - -'}</b></Col>
                                            </Row>
                                            <Row className="">
                                                <Col></Col>
                                                <Col className="text-end text-secondary"><b>{ this.state.form.vipMember ? `Your Cost` : `Payments Received`}</b></Col>
                                                <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "20px !important" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "32%" }}>{ this.state.form.vipMember  ?`$ ${"0.00"}` :this.state.form.totalInvoiceAmountPaid ? `$ ${parseFloat(this.state.form.totalInvoiceAmountPaid).toFixed(2)}` : '- - -'}</b></Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className={`d-flex flex-column pe-5 invoice-message-wraper ${this.state.windowWidth > 1800 ? 'my-5' : 'my-4'}`} style={{ paddingLeft: "4%", textAlign: "justify" }} dangerouslySetInnerHTML={{ __html: this.state?.form?.invoicemessage }}></div>

                                </div>
                            </div>
                            : <div className="d-flex flex-row justify-content-center text-center h-100">
                                <h5 className="d-flex flex-row justify-content-center text-center align-items-center">Sorry, the given invoice number does not exist. Please select another invoice from the Invoices list.</h5>
                            </div>
                }
                <Modal id="transactionModal" show={this.state.transactionModal} centered onHide={() => this.setState({ transactionModal: false })}>
                    <Modal.Header closeButton>
                        <h5 className="text-secondary">Transaction History</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <Table responsive className="p-3">
                            <tbody>
                                <tr className="px-3 header">
                                    <td>Ctbids Transaction Id</td>
                                    <td>Date</td>
                                    <td>Transaction Type</td>
                                    <td>Payment Mode</td>
                                    <td>PayPal Status</td>
                                    <td>Amount</td>
                                    <td>Notes</td>
                                    <td>Response Code</td>
                                </tr>
                                {this.state.transactionData.length ?
                                    this.state.transactionData.map(data =>
                                        <tr className="px-3">
                                            <td>{data.referencenumber ? data.referencenumber : '- - -'}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{data.createddate ? `${moment.utc(data.createddate).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}` : '- - -'}</td>
                                            <td>{data.credit ? 'Credit' : 'Debit'}</td>
                                            <td>{data.paymentmode ? data.paymentmode : '- - -'}</td>
                                            <td>{data.paypalstatus ? data.paypalstatus.toLowerCase() : data.status ? data.status.toLowerCase() : '- - -'}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{data.amount ? `$ ${data.amount.toFixed(2)}` : '- - -'}</td>
                                            <td>{data.comments ? data.comments : 'Manual Payment'}</td>
                                            <td>{data.tranresponse ?
                                                <div>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.getTransactionMessage(data.tranresponse)}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div> : '- - -'}
                                            </td>
                                        </tr>
                                    ) :
                                    <tr><td colSpan="6"><h5 className="noData" >No Data Found</h5></td></tr>
                                }
                            </tbody>
                        </Table>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default connect(state => state)(InvoiceRaView);